export default function load() {
    const listeners = {};
    const addListener = function (key, callback) {
        if (listeners[key] === undefined)
            listeners[key] = [];
        listeners[key].push(callback);
    };
    const removeListener = function (key, callback) {
        if (listeners[key] !== undefined) {
            const index = listeners[key].indexOf(callback);
            if (index > -1) {
                listeners[key].splice(index, 1);
            }
        }
    };
    const notify = function (key, ...data) {
        if (listeners[key] !== undefined) {
            for (let i = 0; i < listeners[key].length; i++) {
                const callback = listeners[key][i];
                try {
                    callback(...data);
                } catch (error) {
                    console.error("webViewManager.notify:", key, error);
                }
            }
        } else {
            console.info("webViewManager.notify: no listeners for key", key);
        }
    };

    const state = {};

    window.webViewManager = {
        addListener, removeListener, notify,
        state
    };
}
